module.exports = "data:image/gif;base64,R0lGODlhIAAgAMQAAPf39/+EKf6CJv2CJoSEhGBNHFNLG1NEG1JGDUhAFURBGz45Ejc5CzAvEigvCiEkEQghCBccCQgZCDoAADEAAAgICCEAABkAABAAAAAAAP///wAAAAAAAAAAAAAAAAAAACH5BAEHABoALAAAAAAgACAAAAW0oCaOZGmeaKqubOu+cCzPM0HQq+1mfO//QOAIkAkYj5IMxdKbUC69o1STERWlyYBkKzFyu4GE1GilYqPjcSMTGY94Z3ha+sgs5tqrF40PGHh3aVlIGVB9Rn92c4N7GHp4CjwFi49Jcn0OkpRxj3MLgJtITJ1pCBkNeIxGB5epGWBHb69YXRIRDagBDgwNYBBpIhVWsHs9Wz0UEcSxwiRflkE+z8c4Ojgn1tfa29zd3t/g4RohADs="


//////////////////
// WEBPACK FOOTER
// ./static/images/MapIcon/Car/CHeadE2_S5.gif
// module id = MYhf
// module chunks = 48